import { Text } from "../../../../components/common/typography";

export function Th({ children, align = "left" }: { children: React.ReactNode; align?: "left" | "right" }) {
  return (
    <th className={`px-4 py-3 ${align === "right" ? "text-right" : "text-left"}`}>
      <Text variant="capsSm" tone="muted" inline>{children}</Text>
    </th>
  );
}

export function Td({ children, align = "left" }: { children: React.ReactNode; align?: "left" | "right" }) {
  return (
    <td className={`px-4 py-3 align-top ${align === "right" ? "text-right" : ""}`}>
      <div className="flex flex-col gap-0.5">{children}</div>
    </td>
  );
}
